import React, { useRef } from "react";
import {
  Autocomplete,
  Backdrop,
  BackdropRoot,
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  ThemeProvider,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { useEffect, useState, useMemo } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

import { useFormik } from "formik";
import * as yup from "yup";
import dayjs from "dayjs";

import { createTheme } from "@mui/material/styles";

import { toast } from "react-toastify";
import axios from "axios";
import { ToastContainer } from "react-toastify/dist";
import Loader from "../../../components/Loader";

import InputLabel from "@mui/material/InputLabel";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";
import { DesktopDateTimePicker } from "@mui/x-date-pickers/DesktopDateTimePicker";
import Stack from "@mui/material/Stack";
import { Link } from "react-router-dom";

export default function AddEmployee() {
  const [open, setOpen] = useState(false);
  const [state, setstate] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [location, setLocation] = React.useState({
    hrcCsm: "",
    csmManager: "",
    locationClass: "",
    status: "",
    locationId: "",
    approved: "",
  });
  const [mappedData, setmappedData] = useState({
    desg: "",
    role: "",
    transit: "",
    org: "",
    organisation: "",
  });
  const [dataAutoComplete, setdataAutoComplete] = useState({
    location: null,
    org: null,
  });
  const [buttonDisable, setbuttonDisable] = useState(false);
  const [value, setValue] = React.useState();
  const handleMouseDownPassword = () => setShowPassword(!showPassword);
  const handleClickShowPassword = () => setShowPassword(!showPassword);

  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
        },
      },
    },
    palette: {
      primary: {
        main: "#FFA500", //this overide blue color
      },
    },
  });

  // console.log(value?.$d);

  // const Designations = async () => {
  //   try {
  //     const res = await axios(
  //       `${process.env.REACT_APP_COMMON_API}/Altracia01-0.0.1/master/getAllDesignations`
  //     );

  //     console.log(res.data);

  //     if (res.data.responseStatus.statusCode == 200) {
  //       setmappedData({
  //         desg: res.data.designationMaster,
  //       });
  //     } else {
  //       await toast.error(res.data.responseStatus.statusDescription, {
  //         theme: "colored",
  //       });
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     await toast.error("Something went wrong !! Please check your network", {
  //       theme: "colored",
  //     });
  //   }
  // };
  // const roles = async () => {
  //   try {
  //     const res = await axios(
  //       `${process.env.REACT_APP_COMMON_API}/Altracia01-0.0.1/master/getAllRoles`
  //     );

  //     console.log(res.data);
  //     if (res.data.responseStatus.statusCode == 200) {
  //       setmappedData({
  //         role: res.data.roleMaster,
  //       });
  //     } else {
  //       await toast.error(res.data.responseStatus.statusDescription, {
  //         theme: "colored",
  //       });
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     await toast.error("Something went wrong !! Please check your network", {
  //       theme: "colored",
  //     });
  //   }
  // };
  // const transits = async () => {
  //   try {
  //     const res = await axios(
  //       `${process.env.REACT_APP_COMMON_API}/Altracia01-0.0.1/master/getAllTransits`
  //     );

  //     console.log(res.data);
  //     if (res.data.responseStatus.statusCode == 200) {
  //       setmappedData({
  //         transit: res.data.transitMaster,
  //       });
  //     } else {
  //       await toast.error(res.data.responseStatus.statusDescription, {
  //         theme: "colored",
  //       });
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     await toast.error("Something went wrong !! Please check your network", {
  //       theme: "colored",
  //     });
  //   }
  // };
  const fetchUser = async () => {
    try {
      setOpen(true);
      const res = await axios(
        `${process.env.REACT_APP_COMMON_API}/location/getAllLocations`
      );
      const res1 = await axios(
        `${process.env.REACT_APP_COMMON_API}/master/getAllRoles`
      );
      const res2 = await axios(
        `${process.env.REACT_APP_COMMON_API}/master/getAllDesignations`
      );
      const res3 = await axios(
        `${process.env.REACT_APP_COMMON_API}/employee/getAllEmployees`
      );
      const res4 = await axios(
        `${process.env.REACT_APP_COMMON_API}/master/getAllOrganizations`
      );

      await Promise.all([res, res1, res2, res3]).then((values) => {
        // console.log({ values });

        if (
          values[0].data.responseStatus.statusCode == 200 &&
          values[1].data.responseStatus.statusCode == 200 &&
          values[2].data.responseStatus.statusCode == 200 &&
          values[3].data.responseStatus.statusCode == 200 &&
          values[4].data.responseStatus.statusCode == 200
        ) {
          const ids = values[0].data.employeeResponse.map((o) => o.city);
          const filtered = values[0].data.employeeResponse.filter(
            ({ city }, index) => !ids.includes(city, index + 1)
          );
          const idss = values[3].data.employeeResponse.map((o) => o.employee);
          const filteredd = values[3].data.employeeResponse.filter(
            ({ employee }, index) => !idss.includes(employee, index + 1)
          );
          setmappedData({
            transit: filtered,
            role: values[1].data.roleMaster,
            desg: values[2].data.designationMaster,
            org: filteredd,
            organisation: values[4].data.masterEntities,
          });

          setOpen(false);
        } else {
          setOpen(false);
          toast.error(values[0].data.responseStatus.statusMessage, {
            theme: "colored",
            // toastId: customId1,
          });
        }
      });

      // console.log({ res, res1 });
    } catch (error) {
      setOpen(false);
      console.log(error);
      await toast.error("Something went wrong", {
        theme: "colored",
      });
    }
  };

  useEffect(async () => {
    fetchUser();
  }, []);

  // useEffect(() => {
  //   Designations();
  //   transits();
  //   roles();
  // }, []);

  const resetValues = useRef(null);

  const resetter = () => {
    resetValues.current.click();
  };

  const validationSchema = yup.object({
    payrollid: yup
      .number("Enter your Payroll-Id")
      .min(10, "Payroll-Id should be of minimum 2 characters length")
      .max(1000000, "PhoneNumber should be of maximum 7 characters length")
      .required("Payroll-Id is required"),
    password: yup
      .string("Enter Your Password")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
        "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
      )
      .required("Password required"),
    employeename: yup
      .string("Enter your Employee Name")
      .min(2, "Employee Name should be of minimum 2 characters length")
      .required("Employee Name is required"),
    username: yup
      .string("Enter Your Username")
      .min(3, "Username should be at least 3 characters long")
      .required("*Username is required")
      .matches(/^(\S+$)/g, "* This field cannot contain  blankspaces"),
    email: yup.string().email("E-Mail must be valid").max(255),
    contact: yup
      .number("Enter your PhoneNumber")
      .min(1000000000, "PhoneNumber should be of minimum 10 characters length")
      .max(
        100000000000,
        "PhoneNumber should be of maximum 11 characters length"
      )
      .required("PhoneNumber is required"),
  });

  const formik = useFormik({
    initialValues: {
      city: "",
      contact: "",
      email: "",
      state: "",
      payrollid: "",
      name: "",
      hrcCsm: "",
      csmManager: "",
      locationClass: "",
      status: "",
    },

    onReset: (initialValues) => ({
      values: { initialValues },
    }),
    validateOnChange: true,

    validationSchema: validationSchema,

    onSubmit: async (values) => {
      try {
        setOpen(true);
        const res = await axios.post(
          `${process.env.REACT_APP_COMMON_API}/employee/addEmployee`,
          {
            employeePrimaryEntity: {
              employeename: values.employeename,
              password: values.password,
              email: values.email,
              contact: values.contact,
              payrollid: values.payrollid,
              designationid: location?.csmManager,
              roleid: location?.locationClass,
              ogranisation: dataAutoComplete?.org.ogranisation,
            },
            employeeSecondaryEntity: {
              // userid: {
              //   userid: "1",
              // },
              joiningdate: value?.$d,
              locationid: dataAutoComplete?.location.locationid,
              // monthlyctc: "1200",
              addedby: "2",
              approved: location?.approved,
              currentstatus: location?.status,
            },
          }
        );
        if (res.data.statusCode == 200) {
          setOpen(false);
          await formik.handleReset();
          await resetter();

          await setTimeout(async () => {
            await toast.success("Employee Created SuccessFully", {
              theme: "colored",
            });
          }, 100);
        } else {
          setOpen(false);
          await setTimeout(async () => {
            await toast.error(res.data.statusDescription.description, {
              theme: "colored",
            });
          }, 100);
        }
      } catch (error) {
        setOpen(false);
        console.log(formik.errors);
        console.log(error);
        await setTimeout(async () => {
          await toast.error("Something went wrong", {
            theme: "colored",
          });
        }, 100);
      }
    },
  });

  return (
    <>
      {" "}
      <section class="form_card mt-5">
        <ToastContainer autoClose={5000} />

        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
        >
          <Loader />
        </Backdrop>
        <div class="container-fluid">
          <div class="card d-block" id="new_store_entry">
            <div class="card-header p-3 position-relative border-0 bg-white">
              <div class="ttl_bx position-absolute d-flex mt_n4">
                <i class="fas fa-user d-block m-auto"></i>
              </div>
              <div class="d-flex justify-content-between title_8 ms_5">
                <p>Add Employee</p>
                <p class="text-sm mb-0 text-capitalize fw-bold">
                  Fields mark with!!
                  <span class="text-danger fw-bold">*</span> are mandatory.
                </p>
              </div>
            </div>
            <div class="card-body p-4 mt-5">
              <form onSubmit={formik.handleSubmit} class="m-0">
                <div class="card card_8 d-block">
                  <div class="d-flex align-items-center w_30 mt_n3 ms-5 me-auto">
                    <i class="fas fa-envelope d-block" aria-hidden="true"></i>
                    <span class="d-block w-100 text-uppercase ms-2">
                      New Employee Form
                    </span>
                  </div>
                  <div class="card-body">
                    <ThemeProvider theme={theme}>
                      <div class="row">
                        <div className="col-md-3">
                          <TextField
                            required
                            className="w-100"
                            label="Employee Name"
                            name="employeename"
                            variant="outlined"
                            size="small"
                            type="text"
                            value={formik.values.employeename}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.employeename &&
                              Boolean(formik.errors.employeename)
                            }
                            helperText={
                              formik.touched.employeename &&
                              formik.errors.employeename
                            }
                          />
                        </div>
                        <div className="col-md-3">
                          <TextField
                            required
                            className="w-100"
                            label="Username"
                            name="username"
                            variant="outlined"
                            size="small"
                            type="text"
                            value={formik.values.username}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.username &&
                              Boolean(formik.errors.username)
                            }
                            helperText={
                              formik.touched.username && formik.errors.username
                            }
                          />
                        </div>
                        <div className="col-md-3">
                          <TextField
                            required
                            className="w-100"
                            label="Password"
                            name="password"
                            type={showPassword ? "text" : "password"}
                            variant="outlined"
                            size="small"
                            value={formik.values.password}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.password &&
                              Boolean(formik.errors.password)
                            }
                            helperText={
                              formik.touched.password && formik.errors.password
                            }
                            InputProps={{
                              // <-- This is where the toggle button is added.
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                  >
                                    {showPassword ? (
                                      <VisibilityIcon
                                        sx={{ color: "#85CBF2" }}
                                      />
                                    ) : (
                                      <VisibilityOffIcon
                                        sx={{ color: "#85CBF2" }}
                                      />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </div>
                        <div className="col-md-3">
                          <TextField
                            required
                            className="w-100"
                            label="E-Mail"
                            name="email"
                            variant="outlined"
                            size="small"
                            type="email"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.email &&
                              Boolean(formik.errors.email)
                            }
                            helperText={
                              formik.touched.email && formik.errors.email
                            }
                          />
                        </div>
                      </div>
                      <div class="row mt-4">
                        <div className="col-md-3">
                          <TextField
                            required
                            className="w-100"
                            label="Contact No."
                            name="contact"
                            variant="outlined"
                            size="small"
                            type="number"
                            value={formik.values.contact}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.contact &&
                              Boolean(formik.errors.contact)
                            }
                            helperText={
                              formik.touched.contact && formik.errors.contact
                            }
                            onInput={(e) => {
                              e.target.value = Math.max(
                                0,
                                parseInt(e.target.value)
                              )
                                .toString()
                                .slice(0, 10);
                            }}
                          />
                        </div>

                        <div className="col-md-3">
                          <TextField
                            required
                            className="w-100"
                            label="Payroll-Id"
                            name="payrollid"
                            variant="outlined"
                            size="small"
                            type="number"
                            onInput={(e) => {
                              e.target.value = Math.max(
                                0,
                                parseInt(e.target.value)
                              )
                                .toString()
                                .slice(0, 6);
                            }}
                            value={formik.values.payrollid}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.payrollid &&
                              Boolean(formik.errors.payrollid)
                            }
                            helperText={
                              formik.touched.payrollid &&
                              formik.errors.payrollid
                            }
                          />
                        </div>
                        {/* <div className="col-md-3">
                          <FormControl required fullWidth>
                            <InputLabel
                              size="small"
                              id="demo-simple-select-label"
                            >
                              Cost Bucket
                            </InputLabel>
                            <Select
                              size="small"
                              required
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={location.csmManager}
                              label="Cost Bucket"
                              onChange={(e) => {
                                setLocation({
                                  ...location,
                                  csmManager: e.target.value,
                                });
                              }}
                            >
                              {mappedData.desg &&
                                mappedData?.desg?.map((map) => {
                                  return (
                                    <MenuItem value={map.designationid}>
                                      {map.designation}
                                    </MenuItem>
                                  );
                                })}
                            </Select>
                          </FormControl>
                        </div> */}
                        <div className="col-md-3">
                          <FormControl required fullWidth>
                            <InputLabel
                              size="small"
                              id="demo-simple-select-label"
                            >
                              Role
                            </InputLabel>
                            <Select
                              size="small"
                              required
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={location?.locationClass}
                              label="Role"
                              onChange={(e) => {
                                setLocation({
                                  ...location,
                                  locationClass: e.target.value,
                                });
                              }}
                            >
                              {mappedData?.role &&
                                mappedData?.role?.map((map) => {
                                  return (
                                    <MenuItem value={map.roleid}>
                                      {map.role}
                                    </MenuItem>
                                  );
                                })}
                            </Select>
                          </FormControl>
                        </div>

                        <div className="col-md-3">
                          <Autocomplete
                            fullWidth
                            required
                            size="small"
                            disablePortal
                            id="combo-box-demo"
                            // options={mappedData.transit}
                            // getOptionLabel={(option) => `${option.city}`}
                            // value={dataAutoComplete.location}
                            // onChange={(e, val) => {
                            //   setdataAutoComplete({
                            //     ...dataAutoComplete,
                            //     location: val,
                            //   });
                            // }}
                            renderInput={(params) => (
                              <TextField
                                required
                                {...params}
                                size="small"
                                label="Organisation"
                              />
                            )}
                          />
                          {/* <FormControl required fullWidth>
                            <InputLabel
                              size="small"
                              id="demo-simple-select-label"
                            >
                              Location
                            </InputLabel>
                            <Select
                              size="small"
                              required
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={location.status}
                              label="Location-Id"
                              onChange={(e) => {
                                setLocation({
                                  ...location,
                                  status: e.target.value,
                                });
                              }}
                            >
                              {mappedData.transit &&
                                mappedData.transit?.map((map) => {
                                  return (
                                    <MenuItem value={map.locationid}>
                                      {map.name}
                                    </MenuItem>
                                  );
                                })}
                            </Select>
                          </FormControl> */}
                        </div>
                      </div>

                      <div class="row mt-4">
                        <div className="col-md-3">
                          <Autocomplete
                            fullWidth
                            required
                            size="small"
                            disablePortal
                            id="combo-box-demo"
                            options={mappedData?.transit}
                            getOptionLabel={(option) => `${option.city}`}
                            value={dataAutoComplete?.location}
                            onChange={(e, val) => {
                              setdataAutoComplete({
                                ...dataAutoComplete,
                                location: val,
                              });
                            }}
                            renderInput={(params) => (
                              <TextField
                                required
                                {...params}
                                size="small"
                                label="Location"
                              />
                            )}
                          />
                        </div>
                        <div className="col-md-3">
                          <LocalizationProvider
                            dateAdapter={AdapterDayjs}
                            style={{ zIndex: "10px" }}
                            fullWidth
                          >
                            <DateTimePicker
                              fullWidth
                              onError={(e) => {
                                if (e) {
                                  setbuttonDisable(true);
                                } else {
                                  setbuttonDisable(false);
                                }
                              }}
                              minDate={dayjs(new Date())}
                              renderInput={(props) => (
                                <TextField
                                  fullWidth
                                  className="w-100"
                                  required
                                  size="small"
                                  style={{ zIndex: "10px" }}
                                  {...props}
                                  helperText={
                                    "(Format - mm/dd/yyyy hh:mm (A/P)m)"
                                  }
                                />
                              )}
                              style={{ zIndex: "10px" }}
                              label="Joining Date"
                              value={value}
                              onChange={(newValue) => {
                                setValue(newValue);
                              }}
                            />
                          </LocalizationProvider>
                        </div>
                        {/* <div className="col-md-3">
                          <Autocomplete
                            fullWidth
                            required
                            size="small"
                            disablePortal
                            id="combo-box-demo"
                            options={mappedData.org}
                            getOptionLabel={(option) =>
                              `${option.ogranisation}`
                            }
                            value={dataAutoComplete.org}
                            onChange={(e, val) => {
                              setdataAutoComplete({
                                ...dataAutoComplete,
                                org: val,
                              });
                            }}
                            renderInput={(params) => (
                              <TextField
                                required
                                {...params}
                                size="small"
                                label="Organisation"
                              />
                            )}
                          />
                        </div> */}
                        {/* <div className="col-md-3">
                          <FormControl required fullWidth>
                            <InputLabel
                              size="small"
                              id="demo-simple-select-label"
                            >
                              Approved
                            </InputLabel>
                            <Select
                              size="small"
                              required
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={location.approved}
                              label="Approved"
                              onChange={(e) => {
                                setLocation({
                                  ...location,
                                  approved: e.target.value,
                                });
                              }}
                            >
                              <MenuItem value="true">Yes</MenuItem>
                              <MenuItem value="False">No</MenuItem>
                            </Select>
                          </FormControl>
                        </div> */}
                        <div className="col-md-3">
                          <FormControl required fullWidth>
                            <InputLabel
                              size="small"
                              id="demo-simple-select-label"
                            >
                              Status
                            </InputLabel>
                            <Select
                              size="small"
                              required
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={location.status}
                              label="Status"
                              onChange={(e) => {
                                setLocation({
                                  ...location,
                                  status: e.target.value,
                                });
                              }}
                            >
                              <MenuItem value="true">Working</MenuItem>
                              <MenuItem value="False">Not-Working</MenuItem>
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                    </ThemeProvider>

                    <div class="text-end my-4">
                      <Button
                        type="submit"
                        variant="contained"
                        disabled={buttonDisable}
                        sx={{ background: "#F67503" }}
                        endIcon={<SendIcon />}
                      >
                        Submit
                      </Button>
                      <Button
                        ref={resetValues}
                        onClick={() => {
                          formik.handleReset();
                          setLocation({
                            hrcCsm: "",
                            csmManager: "",
                            locationClass: "",
                            status: "",
                          });
                          setstate("");
                          setValue(null);
                          setdataAutoComplete({
                            location: null,
                            org: null,
                          });
                        }}
                        sx={{ marginLeft: "10px", background: "#4C4234" }}
                        type="reset"
                        variant="contained"
                        endIcon={<RestartAltIcon />}
                      >
                        Reset
                      </Button>
                    </div>
                    <div className="text-end">
                      <p> List of Employees </p>
                      <Link className="primary" to="/dashboard/ViewEmployees">
                        <p style={{ color: "#F47C03" }}>Click here !!</p>
                      </Link>
                    </div>

                    {/* <div class="d-flex w-25 mx-auto mt-4"> */}
                    {/* <div class="text-end my-4">
                        <Button
                          type="submit"
                          variant="contained"
                          endIcon={<SendIcon />}
                        >
                          Submit
                        </Button>
                        <Button
                          onClick={() => {
                            formik.handleReset();
                          }}
                          sx={{ marginLeft: "10px" }}
                          type="reset"
                          variant="contained"
                          endIcon={<RestartAltIcon />}
                        >
                          Reset
                        </Button>
                      </div> */}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
